import { GraphQLClient } from 'graphql-request';

import { getSelectedPeriodIdFromLocalStorage } from './selectedPeriod';

async function tokenMiddleware(request) {
  // todo: see how we handle token
  const token = 'fixed token';
  const periodId = getSelectedPeriodIdFromLocalStorage();

  const headers = {
    ...request.headers,
    authorization: `Bearer ${token}`,
  };

  headers['Selected-Period-Id'] = periodId;

  return {
    ...request,
    headers,
  };
}

// Export the clients for synchronous use troughout the app.
export const portfolioServiceQueryClient = new GraphQLClient(
  process.env.REACT_APP_PORTFOLIO_SERVICE_URL,
  {
    requestMiddleware: tokenMiddleware,
  },
);

export const plannerServiceQueryClient = new GraphQLClient(
  process.env.REACT_APP_PLANNER_SERVICE_URL,
  {
    requestMiddleware: tokenMiddleware,
  },
);

export const slideViewerServiceQueryClient = new GraphQLClient(
  process.env.REACT_APP_SLIDEVIEWER_SERVICE_URL,
  {
    requestMiddleware: tokenMiddleware,
  },
);
